import styled from 'styled-components'
import colors from 'utils/colors'
import CustomText from 'components/text/CustomText'
import { useTranslation } from 'react-i18next'
import { MESSAGES } from 'locales/locales'

const DisableOtr = ({disabledOtr}: {disabledOtr: boolean}) => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <CustomText typography="body2" textAlign="center">
        {disabledOtr
          ? t(MESSAGES.DISABLE_OTR_DESCRIPTION)
          : t(MESSAGES.DISABLE_OTR_DESCRIPTION_ONE_USER)}
      </CustomText>
    </Wrapper>
  )
}

export default DisableOtr

const Wrapper = styled.div`
  display: flex;
  height: 120px;
  border-top: 1px solid ${colors.light80};
  align-items: center;
  justify-content: center;
  column-gap: 15px;
`
